import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import BaseModal from '../../../_shared/components/BaseModal';
import {
  ModalButtonContainer,
  ModalCloseButton,
  ModalContent,
  ModalSaveButton
} from './Styles';

const propTypes = {
  testId: PropTypes.string,
  isModalOpen: PropTypes.bool,
  closeHandler: PropTypes.func,
  saveHandler: PropTypes.func,
  disableSaveCondition: PropTypes.bool,
  isOmp: PropTypes.bool
};

const defaultProps = {
  testId: undefined,
  isModalOpen: false,
  closeHandler: undefined,
  saveHandler: undefined,
  disableSaveCondition: true,
  isOmp: false
};

const RetailToolsEditModal = ({
  testId,
  isModalOpen,
  closeHandler,
  saveHandler,
  disableSaveCondition,
  isOmp,
  children
}) => {
  return (
    <BaseModal
      isOpen={isModalOpen}
      padding="0"
      bodyOpenClassName="ReactModal__FullScreen"
      variant="retailToolsEditModal"
      width={500}
      isClickEscClose
      isClickOverlayClose
      onRequestClose={closeHandler}
      data-testid={`${testId}-modal`}
    >
      <ModalContent>
        {children}

        <ModalButtonContainer>
          <ModalCloseButton
            onClick={closeHandler}
            data-testid={`${testId}-closeButton`}
          >
            <FormattedMessage id="modal.cancel" />
          </ModalCloseButton>
          <ModalSaveButton
            testId={`${testId}-save-button`}
            onClick={saveHandler}
            disabled={disableSaveCondition}
            isOmp={isOmp}
          >
            <FormattedMessage id="list.filters.save" />
          </ModalSaveButton>
        </ModalButtonContainer>
      </ModalContent>
    </BaseModal>
  );
};

RetailToolsEditModal.propTypes = propTypes;
RetailToolsEditModal.defaultProps = defaultProps;

export default RetailToolsEditModal;
